export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
}

export const categories: Category[] = [
  {
    slug: '91-video',
    name: '91视频',
    description: '91视频专区，海量高清影视资源免费在线观看，每日更新热门电影电视剧',
    icon: 'ri-movie-2-line',
    color: 'primary',
  },
  {
    slug: '97-video',
    name: '97视频',
    description: '97视频频道，精选热门大片免费看，高清画质不卡顿',
    icon: 'ri-film-line',
    color: 'accent',
  },
  {
    slug: '51-video',
    name: '51视频',
    description: '51视频平台，最新电视剧全集在线观看，会员免费追剧',
    icon: 'ri-tv-2-line',
    color: 'secondary',
  },
  {
    slug: '92-video',
    name: '92视频',
    description: '92视频资源站，电影电视剧综艺全覆盖，高清流畅播放',
    icon: 'ri-play-circle-line',
    color: 'primary',
  },
  {
    slug: '98-video',
    name: '98视频',
    description: '98视频在线，经典老片新片一网打尽，随时随地想看就看',
    icon: 'ri-clapperboard-line',
    color: 'accent',
  },
  {
    slug: 'xiaolan-video',
    name: '小蓝视频',
    description: '小蓝视频专区，独家高清资源不卡顿免费看，极速加载体验',
    icon: 'ri-vidicon-line',
    color: 'secondary',
  },
  {
    slug: 'yaojing-video',
    name: '妖精视频',
    description: '妖精视频频道，热门精品影视推荐，高清无广告流畅观看',
    icon: 'ri-live-line',
    color: 'primary',
  },
];